import React from "react";
import { Avatar } from "src/components/header/styles";
import styled from "styled-components";

import demoPic from "src/assets/png/userd-demo-pic.png";
import { useAuth } from "src/contexts/auth";
import CurrentPlan from "src/screens/checkout/CurrentTrainerPlan";

const Wrapper = styled.div`
  flex: 1;
  flex-direction: column;

  padding: 10px;

  max-width: 1000px;

  h3 {
    padding-left: 15px;
    font-weight: bold;
  }
`;

const Section = styled.div`
  border-radius: 5px;
  height: 40px;
  min-width: 40%;

  flex: 1;

  flex-direction: column;

  padding-inline: 5px;

  h4 {
    font-weight: bold;
    font-size: 14px;

    align-items: center;

    color: #888;

    > * {
      font-size: 20px;
      margin-right: 5px;
    }
  }

  > p {
    font-size: 14px;
  }

  > a {
    color: #444;
    font-weight: 600;
    font-size: 14px;
    text-decoration: #444 solid underline;
    cursor: pointer;
  }

  margin-bottom: 10px;
`;

const TrainerSettings: React.FC = () => {
  const { user } = useAuth();

  return (
    <div className="fade-in flex flex-1 items-center justify-center">
      <div className="flex max-w-7xl flex-1 flex-col p-2">
        <div className="mb-3 flex flex-row flex-wrap justify-between rounded-md border border-zinc-150 bg-zinc-50 p-2 dark:border-zinc-700 dark:bg-zinc-800">
          <div className="flex flex-row items-center pb-2">
            <Avatar src={demoPic} />
            <h3 className="pl-4 font-bold text-zinc-900 dark:text-zinc-100">
              {user?.name}
            </h3>
          </div>
          <div className="flex w-full flex-col pb-5">
            <h2 className="text-lg font-semibold text-zinc-900 dark:text-zinc-100">
              Informaçoes Pessoais
            </h2>
            <p className="text-zinc-600 dark:text-zinc-400">
              Dados de Cadastro
            </p>
          </div>
          <div className="mb-2 flex min-w-[40%] flex-1 flex-col rounded-md px-1">
            <h4 className="flex items-center text-sm font-bold text-zinc-500 dark:text-zinc-400">
              Nome:
            </h4>
            <p className="text-sm text-zinc-800 dark:text-zinc-200">
              {user?.name}
            </p>
          </div>
          <div className="mb-2 flex min-w-[40%] flex-1 flex-col rounded-md px-1">
            <h4 className="flex items-center text-sm font-bold text-zinc-500 dark:text-zinc-400">
              Slogan:
            </h4>
            <p className="text-sm text-zinc-800 dark:text-zinc-200">
              {user?.name_pj}
            </p>
          </div>
        </div>

        <div className="mb-3 flex flex-row flex-wrap justify-between rounded-md border border-zinc-150 bg-zinc-50 p-2 dark:border-zinc-700 dark:bg-zinc-800">
          <div className="flex w-full flex-col pb-5">
            <h2 className="text-lg font-semibold text-zinc-900 dark:text-zinc-100">
              Faturamento
            </h2>
            <p className="text-zinc-600 dark:text-zinc-400">
              Planos e Pagamento
            </p>
          </div>
          <CurrentPlan />
        </div>

        <div className="mb-3 flex flex-row flex-wrap justify-between rounded-md border border-zinc-150 bg-zinc-50 p-2 dark:border-zinc-700 dark:bg-zinc-800">
          <div className="flex w-full flex-col pb-5">
            <h2 className="text-lg font-semibold text-zinc-900 dark:text-zinc-100">
              Segurança e Acesso
            </h2>
            <p className="text-zinc-600 dark:text-zinc-400">Acessos e senhas</p>
          </div>
          <div className="mb-2 flex min-w-[40%] flex-1 flex-col rounded-md px-1">
            <h4 className="flex items-center text-sm font-bold text-zinc-500 dark:text-zinc-400">
              Status de Senha:
            </h4>
            <p className="text-sm text-zinc-800 dark:text-zinc-200">
              Cadastrada
            </p>
          </div>
          <div className="mb-2 flex min-w-[40%] flex-1 flex-col rounded-md px-1">
            <h4 className="flex items-center text-sm font-bold text-zinc-500 dark:text-zinc-400">
              Opções:
            </h4>
            <a className="cursor-pointer text-sm font-semibold text-zinc-700 underline underline-offset-2 dark:text-zinc-200">
              REDEFINIR SENHA
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrainerSettings;
